import type { PropsWithChildren, ReactNode } from "react";
import halo from "../../assets/images/logo-halo.png";
import styles from "./StatusScreen.module.css";

interface StatusScreenProps {
  title: string;
  message?: ReactNode;
}

export const StatusScreen = ({ title, message, children }: PropsWithChildren<StatusScreenProps>) => (
  <section className={`card ${styles.screen}`}>
    <img src={halo} alt="" className={styles.halo} />
    <h1 className={styles.title}>{title}</h1>
    {message && <p className={styles.message}>{message}</p>}
    {children && <div className={styles.actions}>{children}</div>}
  </section>
);
